export const links = [
    {
      name: "About us",
      submenu: true,
      sublinks: [
        {
          Head: "Industries",
          sublink: [
            { name: "BioPharma", link: "/biopharma" },
            { name: "Gaming & Web 3.0 Technology", link: "/web3.0-technology" },
            { name: "Transportation & Logistics", link: "/transportation-logistics" },
          ],
        },
      ],
    },
    {
      name: "Services",
      submenu: true,
      sublinks: [
        {
          Head: "Assessments",
          sublink: [
            { name: "Cyber Security Posture Assessment & Maturity Benchmarking", link: "/posture-assessment-maturity" },
            { name: "Threat Risk Assessment", link: "/threat-risk-assessment" },
            { name: "Security Gap Assessment", link: "/gap-assessment" },
            { name: "Vulnerability Assessment", link: "/valnerabiliy-assessment" },
            { name: "Privacy Risk/Impact Assessment", link: "/privacy-risk-impact" },
            { name: "Cybersecurity Architecture Assessment", link: "/architecture-assessment" },
            { name: "Ransomware Preparedness Assessment", link: "/ransomware-preparedness-assessment" },
          ],
        },
        {
          Head: "Security Reviews",
          sublink: [
            { name: "Security Configuration Review", link: "/security-configuration-review" },
            { name: "Secure Code Review", link: "/secure-code-review" },
          ],
        },
        {
          Head: "More Services",
          sublink: [
            { name: "Technical TRA", link: "/technical-tra" },
            { name: "Penetration Testing", link: "/penetration-testing" },
            { name: "Red Teaming", link: "/red-teaming" },
            { name: "Cloud Security Testing", link: "/cloud-security-testing" },
            { name: "Incident Response Management", link: "/incident-response" },
            { name: "Phishing Simulation", link: "/phishing-simulation" },
            { name: "Application Threat Modelling", link: "/application-threat-modelling" },
          ],
        },
      ],
    },
  
  ];
